import React from 'react';
import { Dot } from '../dot/Dot';
import { CheckoutStatus } from '@app/react-common/models/CheckoutStatus';

//either pass checkout and abtest ids or pass status
interface ICheckoutStatusDotsProps {
  status: CheckoutStatus;
  showTooltip?: boolean;
  ignorePadding?: boolean;
}

export const CheckoutStatusDots: React.FC<ICheckoutStatusDotsProps> = ({
  status,
  showTooltip = true,
  ignorePadding = false,
}) => {
  const renderCheckoutStatusDot = (status: CheckoutStatus): React.ReactNode => {
    const returningNodes: React.ReactNode[] = [];

    switch (status) {
      case CheckoutStatus.DefaultAndAbTestRunning:
        returningNodes.push(
          <Dot
            key={1}
            hoverText={'Live checkout'}
            {...(!ignorePadding && { paddingSide: 'left' })}
            color={'green'}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        returningNodes.push(
          <Dot
            key={2}
            hoverText={'A/B test running'}
            {...(!ignorePadding && { paddingSide: 'left' })}
            color={'darkblue'}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
      case CheckoutStatus.LiveAbTestSegmented:
        returningNodes.push(
          <Dot
            key={1}
            hoverText={'Live segmented checkout'}
            {...(!ignorePadding && { paddingSide: 'left' })}
            color={'green'}
            halfFilled={true}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        returningNodes.push(
          <Dot
            key={2}
            hoverText={'A/B test running'}
            {...(!ignorePadding && { paddingSide: 'right' })}
            color={'darkblue'}
            halfFilled={true}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
      case CheckoutStatus.AbTest:
        returningNodes.push(
          <Dot
            key={1}
            hoverText={'A/B test running'}
            {...(!ignorePadding && { paddingSide: 'right' })}
            color={'darkblue'}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
      case CheckoutStatus.Default:
        returningNodes.push(
          <Dot key={1} hoverText={'Live checkout'} color={'green'} tooltipDirection="left" showTooltip={showTooltip} />,
        );
        break;
      case CheckoutStatus.LiveSegmented:
        returningNodes.push(
          <Dot
            key={1}
            color="green"
            hoverText="Segmented live checkout"
            halfFilled={true}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
      case CheckoutStatus.AbTestSegmented:
        returningNodes.push(
          <Dot
            key={1}
            hoverText={'A/B test running'}
            color={'darkblue'}
            halfFilled={true}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
      case CheckoutStatus.DisabledSegmented:
        returningNodes.push(
          <Dot
            key={1}
            color="gray"
            hoverText={'Segmented checkout'}
            halfFilled={true}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
      case CheckoutStatus.Disabled:
        returningNodes.push(
          <Dot
            key={1}
            color="gray"
            hoverText={'Disabled checkout'}
            tooltipDirection="left"
            showTooltip={showTooltip}
          />,
        );
        break;
    }

    return <>{returningNodes}</>;
  };
  return <>{renderCheckoutStatusDot(status)}</>;
};
